module.exports = "/_next/static/images/HeroMobile-e7604c34db1ace0db8a8f9e2b241d7c8.webp";